/* eslint-disable max-len */

export default {
  lang: 'Spanish',
  homeScreen: {
    title: 'Bienvenido a Dallas', // Product specific
    stayConnected: 'Mantente conectado:',
    comingSoon: 'Descargar Ahora',
    messages: 'Mensajes',
  },
  loginScreen: {
    version2: {
      homeTitle: "Vamos a ver si podemos encontrar un perfil existente para usted en nuestro sistema.",
      homeTitleSub: "Introduzca la dirección de correo electrónico que utiliza habitualmente para acceder a los programas de formaci",
      noAccount: "No se ha encontrado ninguna cuenta ({email}), inténtalo con otra dirección de correo electrónico o crea una cuenta ahora.",
      continueButton: "Continuar",
      success: "Ha actualizado correctamente su cuenta. En breve será redirigido a la página de inicio.",
      successNewAccount: "Para completar su inscripción, recibirá un correo electrónico de confirmación para verificar su cuenta.",
      loginButton: "Inicio de sesión",
      matchFound: "Hemos encontrado una coincidencia, por favor, introduzca su contraseña para continuar.",
      magicLink: "Inicie sesión a través de un enlace en su correo electrónico:",
      magicLinkButton: "Solicitar Magic Link",
      magicLinkTitle: "Recibe un enlace directo en tu correo electrónico que te permitirá registrarte al instante.",
      otherEmailButton: "Enviar",
      title: "Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.",
      titleIndustry: "Por favor, tómese un momento para completar toda la información que aparece a continuación, ya que rellenará su perfil personal y su información de contacto.",
      register: "Crear una cuenta",
      agent: "Asesor de viajes",
      visitor: "Visitante del sector",
      step1: "Paso 1: Tipo de usuario",
      step2: "Paso 2: Crear una cuenta",
      step3: "Paso 3: Cree su perfil",
      marketingOptIn: "¿Está seguro de que no le interesa seguir vinculado al equipo de comercio de viajes de este programa?",
      optIn: "Sí, me interesa",
      optOut: "No me interesa",
      step2Sub1: "Háblenos de usted",
      step2Sub2: "Háblenos de su empresa",
      privacyHead: "PREFERENCIAS DE COMUNICACIÓN",
      privacySub: "Marque las casillas que aparecen a continuación para asegurarse de que recibe comunicaciones importantes del equipo comercial de viajes del proveedor (actualizaciones y anuncios de productos, recompensas, incentivos, FAMs, etc.) e iniciativas de redes comerciales de viajes y apoyo a las ventas de TravPRO Mobile.",
      privacy: "Protegemos su privacidad y nunca vendemos, abusamos o traicionamos su confianza.",
      store: "Descarga fácilmente este programa en tu tienda de aplicaciones:",
      powered: "PODER DE",
      toastMessage: {
        forgotSuccess: "Le hemos enviado por correo electrónico un enlace para restablecer su contraseña. Serás redirigido a la página de inicio de sesión en 10 segundos.",
        emailNotExisting: "La dirección de correo electrónico que has introducido no existe.",
        magicLinkMessage: "Por favor, espera, te estamos registrando ahora mismo.",
        magicLinkError: "No hemos podido encontrar tu cuenta en nuestra base de datos, por favor inicia sesión manualmente. Será redirigido en 10 segundos.",
        magicLinkError1: "No hemos podido encontrar un token válido, por favor inicie sesión o solicite un nuevo enlace mágico. Si este problema persiste, póngase en contacto con nosotros en: info@travpromobile.com.",
        magicLinkError2: "No hemos podido encontrar su cuenta en nuestra base de datos, por favor inicie sesión manualmente. Será redirigido en 10 segundos.",
        magicLinkSuccess: "Comprueba tu correo electrónico en {email}. Tiene un enlace mágico que te registrará.",
        magicLinkErrorWait: "Por favor, espera 5 minutos entre peticiones de enlace mágico.",
        emailNotFoundError: "La dirección de correo electrónico que ha introducido no se encuentra en nuestros registros. Por favor, compruebe si hay errores ortográficos o cree una cuenta."
      },
      errors: {
        zipCodeNotFound: "Código postal no encontrado, inténtelo de nuevo",
        zipCodeOnlyNumbers: "El código postal sólo puede contener números",
        password: "Introduzca una contraseña",
        passwordNotMatching: "Las contraseñas introducidas no coinciden",
        passwordTooShort: "La contraseña debe tener al menos 8 caracteres",
        emailExists: "Esta dirección de correo electrónico ya existe o no es válida. Inténtelo con otra dirección de correo electrónico o acceda a su cuenta.",
        fillInAllFields: "Rellene todos los campos obligatorios",
        fillInEmail: "Por favor, introduzca su dirección de correo electrónico.",
        emailNotExisting: "La dirección de correo electrónico que ha introducido no existe."
      },
      fields: {
        forgotSubCopy: "¿Has olvidado tu contraseña y quieres cambiarla? ",
        forgotSubCopy2: "¿Quiere saltarse la contraseña por completo? Le enviaremos un correo electrónico con un enlace mágico que le permitirá acceder automáticamente al programa. ",
        city: "Ciudad",
        companyName: "Nombre de la empresa",
        role: "Su función",
        description: "¿Cuál describe mejor la actividad de su empresa?",
        country: "País",
        password: "Contraseña",
        passwordRegister: "Elija una contraseña (mínimo 8 caracteres)",
        passwordConfirm: "Confirmar contraseña",
        firstName: "Nombre",
        lastName: "Apellido (Familia)",
        agency: "Nombre de su agencia",
        title: "Su función (seleccione una)",
        company: "Nombre de la empresa",
        select: "Seleccione una opción",
        state: "Estado",
        province: "Provincia/Región/Estado",
        zipCode: "Código postal",
        postalCode: "Código postal",
        affiliate: "¿A qué grupo está afiliada su agencia PRINCIPAL?",
        hostAgency: "¿Su agencia de acogida?",
        executive: "Ejecutivo",
        management: "Gestión",
        marketing: "Marketing",
        sales: "Ventas",
        coordinator: "Coordinador",
        opt: "Manténgase en contacto con el equipo de comercio de viajes de este programa y reciba actualizaciones.",
        optMarketing: "Manténgase en contacto con TravPRO en relación con programas y eventos similares.",
        retail: "Fachada de tienda",
        home: "Agente a domicilio",
        independent: "Contratista independiente",
        host: "Organismo anfitrión",
        call: "Centro de llamadas o agencia web",
        other: "Otros",
        describes: "¿Qué es lo que mejor describe su actividad y la de su agencia?"
      }
    },
    title: 'Programa de capacitación para profesionales del turismo y ventas',
    welcome: {
      headerTop: 'BIENVENIDO A',
      headerBottom: 'Visit Dallas PRO', // Product specific
    },
    forgot: '¿Has olvidado tu contraseñ]a?',
    sellingPoints: { // All selling points can be product specific
      0: 'Aprenda, promocione y venda',
      1: 'Entrenamiento multimedia en todos los dispositivos',
      2: 'Certificado de finalización',
      3: 'Presentaciones de ventas listas para usar',
      4: 'Información y recursos de ventas de alto impacto',
      5: 'Sugerencias y promociones de información privilegiada',
      6: 'Directorio de productos en tiempo real',
      7: 'Noticias y actualizaciones oportunas',
    },
    emailPrompt: 'Por favor, ingresa tu dirección de correo electrónico para confirmar que eres un profesional del turismo.',
    tAndC: {
      agree: 'Al continuar, estás de acuerdo con nuestra ',
      privacyPolicy: 'política de privacidad',
      and: ' y nuestros ',
      termsConditions: 'términos y condiciones',
    },
    fields: {
      agency: 'Agencia',
      email: 'Correo electrónico',
      password: 'Clave',
      passwordConfirm: 'Confirmar la contraseña',
      firstName: 'Nombre ',
      lastName: 'Apellido',
      agencyName: 'Nombre de la agencia',
      stateProvince: 'Estado / Provincia',
      required: 'Necesario',
      invalidEmail: 'Dirección de correo electrónico inválida',
      opt: '¡Mantente en contacto! ¡Sí, me gustaría participar en las comunicaciones de Visit Dallas que me mantendrán informado sobre noticias, eventos, incentivos, FAM y más!',
      forgot: '¿Ha olvidado su contraseña? Haz clic en el botón de abajo y te enviaremos un correo electrónico para restablecer tu contraseña.',
    },
    forgot: 'Restablecer contraseña',
    noAgent: {
      noAgentButton: 'No soy un agente',
      title: 'Gracias por interesarte en Visit Dallas PRO Sales Companion.', // Product specific
      messageWeb: 'El contenido de este sitio es exclusivamente para profesionales del turismo. \n Para obtener más información sobre Visit Dallas, por favor visita: ', // Product specific
      messageMobile: 'Parte del contenido de esta aplicación es exclusivo para profesionales del turismo, pero no dudes en echar un vistazo a lo que te ofrece esta aplicación presionando “Continuar”.', // Product specific
      continue: 'Continuar',
      visitWebsite: 'Visita la página web >',
    },
    newUser: 'Nuevo usuario',
    register: 'Registrarse',
    registered: 'Este correo electrónico ya está registrado',
  },
  welcomeScreen: {
    title: 'Bienvenido(a) al\nPrograma de Capacitación y Socio de Ventas de STAR de California',
    helloUser: 'Hola {name}',
    hello: 'Hola,',
    fromAgency: 'de {agency}',
    notUser: '¿No eres {name}?',
    introOnline: '¡Practica inmediatamente en línea o precarga el contenido para que esté siempre disponible para su uso sin conexión!',
    introOffline: 'Ya tienes la última versión precargada. ¡Comienza a practicar o a vender en cualquier momento y en cualquier lugar!',
    startTraining: 'Comenzar a practicar',
    continueTraining: 'Continue learning',
    graduated: 'Felicidades!',
    downloader: {
      preload: 'Precarga',
      stop: 'parar',
      init: 'Iniciando…',
      lastUpdate: 'Última actualización: ',
    },
  },
  trainingScreens: {
    start: 'Empezar',
    continue: 'Continuar',
    restart: 'Reiniciar',
    review: 'Review',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number} % completado',
    unlock: 'Desbloquea este capítulo completando el capítulo {number} de la capacitación.',
    unlockSubtitle: 'Desbloquea más capítulos completando más capítulos de la capacitación.',
    allUnlocked: '¡Has desbloqueado todos los capítulos!',
    certificate: 'Certificado',
    courseComplete: '¡Curso completo!',
    endReached: 'Has llegado al final',
    retainEnd: 'Usa la barra superior para navegar por este capítulo o pulsa el botón atrás para volver a la vista general.',
    watchListenRead: 'Ver, escuchar y leer más',
    trouble: 'Parece que tienes problemas, ¿te gustaría saltarte esta pregunta?',
    confirm: 'Confirma tu respuesta',
    choose: 'Por favor, elige una respuesta',
    skip: 'Regresar >',
    viewAllTitle: 'Sugerencia de entrenamiento',
    viewAll: 'Para pasar a la página siguiente, haga clic en los iconos para ver el contenido complementario. Se han proporcionado videos, mapas y otra información útil para mejorar su entrenamiento y garantizar que alcance el estado PRO.',
    fillBlanks: 'Rellenar los espacios en blanco:',
    next: 'Próxima pregunta',
    retry: 'Intentar otra vez',
    fastTrackText: {
      success: '¡Felicitaciones, aprobó el curso Fast Track y desbloqueó el resto de la capacitación!',
      failed: 'Lamentablemente, no aprobó el curso Fast Track, ¡puede reanudar su capacitación para obtener su diploma!',
    },
    fastTrack: '¡Conviértase en una superestrella de Visit Dallas!',
    fastTrackExplanation: 'Simply take the quiz on the following pages for your chance to win a FAM to Switzerland!<br><br><span style="font-weight: bold">You will find all answers to the quiz questions in the following ways:</span><br><br>1.	The content that you learned in the Rail Europe and Switzerland modules<br><br>2.	And on the following websites:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">Be sure to review these resources in detail before taking the quiz! Only those with the highest of scores will have the chance to be invited to the FAM.</span>',
    fastTrackButton: 'Click Here to Take the Swiss Superstar Quiz',
    grading: 'Your final grade is: {grade}%',
  },
  nav: {
    home: 'Inicio',
    train: 'Capacitación',
    learn: 'Capacitación',
    retain: 'Retener',
    directory: 'Directorio',
    showRoom: 'Focos de hotel',
    showcases: 'Focos de hotel',
    promote: 'Datos rápidos',
    sell: 'Caja de herramientas',
    info: 'Información',
    rewards: 'Rewards',
    media: 'Multimedia',
    favorites: 'Favoritos',
    contact: 'Contacto',
    reportCard: 'Calificaciones',
    accountSettings: 'Configuración de la cuenta',
    messages: 'Mensajes',
    search: 'Buscar',
  },
  contentHeaders: {
    train: 'Biblioteca de capacitación',
    retain: 'Retener',
    subapps: 'Mini capacitación para socios de Visit Dallas',
    maintrainings: 'Módulos esenciales',
    subtrainings: 'Módulos de Especialización',
  },
  pageDescriptions: {
    train: 'Eduque, participe y conviértase en un experto.',
    showroom: '',
    retain: 'Su recurso de referencia para retener su conocimiento experto y habilitar sus esfuerzos de ventas. Utilice esta área para responder de manera experta a una pregunta sobre un producto o incluso como una presentación de ventas improvisada, en cualquier momento, en cualquier lugar y desde cualquier dispositivo.',
    promote: 'Inicie la conversación con sus clientes y prospectos.',
    sell: 'Responda las preguntas de los clientes y cierre la venta.',
    favorites: 'Mira tu contenido favorito personal',
    search: 'Mira todo el contenido',
    subapps: '',
    maintrainings: 'Complete estos módulos para aprender los conceptos básicos para vender Visit Dallas.',
    subtrainings: 'Conozca los productos específicos',
  },
  general: {
    next: 'Siguiente',
    yes: 'Sí',
    no: 'No',
    previous: 'Anterior',
    submit: 'Enviar',
    back: 'Atrás',
    close: 'Cerrar',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Iniciar sesión',
    logOut: 'Cerrar sesión',
    viewItem: 'Ver {type}',
    imageNotFound: 'Imagen no encontrada',
    noResultsFor: 'No se han encontrado resultados para: {{query}}',
    noFavorites: 'Aún no tienes ningún favorito.',
    noMessages: '¡Todavía no has recibido ningún mensaje!',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar todos',
    connectionError: 'Error de conexión',
    alreadyExists: 'Ya existe',
    pageNotFound: '¡404 Página no encontrada!',
    oops: 'Uh oh...',
    overview: 'Volver a la vista general',
    complete: 'Continuar',
    courseComplete: '¡Curso terminado!',
    chapterComplete: '¡Capítulo completado!',
    message: '{count} Mensaje',
    messagePlural: '{count} Mensajes',
  },
  itemTypes: {
    image: 'Imagen',
    brochure: 'Compilación',
    layout: 'Esquema',
    web: 'Página web',
    pdf: 'PDF',
    carousel: 'Compilación',
  },
  questions: {
    dials: 'Gira los discos para que coincidan con la respuesta',
    fitb: 'Llena los espacios en blanco',
    flip: 'Cambia el número para que coincida con la respuesta',
    multipleChoice: 'Elige la(s) respuesta(s) correcta(s)',
    slider: 'Elige la respuesta correcta usando el control deslizante',
    map: 'Contesta la pregunta tocando el lugar correcto en el mapa',
    dropdown: 'Selecciona…',
    true: 'Verdadero',
    false: 'Falso',
  },
  reportCard: {
    download: 'Descargar',
    email: 'Correo electrónico',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'ACEPTAR',
    optout: 'Darse de baja',
    settings: 'Ajustes de privacidad',
    message: '¡No nos has contado nada sobre tus preferencias de confidencialidad de datos! No hay problema, pero nos gustaría ofrecerte la mejor experiencia utilizando la característica Socio de Ventas.',
    disabled: 'Parece que deshabilitaste el uso de cookies.',
    use: 'El {appName} necesita el uso de cookies para darte la mejor experiencia.',
    details: '¿Para qué se utilizan las cookies?',
    enable: 'Mira cómo habilitar tus cookies {here}.',
    here: 'aquí',
  },
  notLoggedIn: {
    super: 'No has iniciado sesión',
    title: 'Necesitas iniciar sesión para ver este contenido',
    guest: 'Invitado',
  },
  demo: {
    message: 'Este sitio web es una demostración del producto final. Actualmente está en desarrollo y no es un producto completo.',
    consent: '¡Entendido!',
  },
  share: {
    header: '¡Comparte este material en tus redes sociales favoritas!',
    download: 'download',
  },
  sharing: {
    copyURL: 'Copiar link',
    copied: 'Copiado',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header: 'Parece que estás intentando acceder a la aplicación {appName} desde un dispositivo móvil',
    body: 'Para descargar este programa, simplemente visita la tienda de aplicaciones y busca {appName} o haz clic en uno de los siguientes botones',
    benefits: {
      header: 'Esto te dará:',
      1: 'Certificado de finalización',
      2: 'Materiales de marketing gratuitos y de alta calidad',
      3: 'Califica para participar en destino FAMS',
      4: 'Información y recursos de ventas de alto impacto',
      5: 'Acceso a la aplicación móvil Sales Companion',
      6: 'Consejos de venta',
    },
  },
  custom: {
    splitUsers: 'Soy un(a) ...',
    brandAmbassador: 'Embajador(a) de la marca',
    travelPro: 'Profesional de viajes',
  },
  directoryView: {
    results: 'Cantidad de resultados',
    search: 'Buscar un hotel...',
    filter: 'Filtrar por categoría',
    category: {
      architecture: 'Arquitectura, arte, cultura e historia',
      airports: 'Aeropuertos',
      breweries: 'Cervecerías y salas de grifo',
      churches: 'Iglesias',
      distillery: 'Destilería y degustación',
      hotels: 'Hoteles',
      meetings: 'Reuniones',
      neighborhoods: 'Barrios',
      nightlife: 'La vida nocturna',
      outdoor: 'Recreación al aire libre',
      restaurants: 'Restaurantes',
      restaurantsNightlife: 'Restaurantes con vida nocturna',
      sports: 'Sedes deportivas',
      tours: 'Excursiones',
    },
  },
};
